import { Button } from "@/components/ui/Button";
import { useAppUpdate } from "./AppUpdateProvider";

export function AppUpdateBanner() {
  const { pendingUpdate, reloadNow } = useAppUpdate();
  if (!pendingUpdate) return null;

  return (
    <div
      role="status"
      data-eh-layout-banner=""
      className="border-b border-accent/30 bg-accent-soft px-4 py-2 text-sm text-label sm:px-6"
    >
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-2">
        <p>
          Eine neue Version ist verfügbar. Beim nächsten Seitenwechsel wird die App automatisch
          aktualisiert.
        </p>
        <Button type="button" size="sm" variant="secondary" onClick={reloadNow}>
          Jetzt aktualisieren
        </Button>
      </div>
    </div>
  );
}
